import { useChart } from "./index";
import { Card, CardHeader } from "@mui/material";
import Chart from "react-apexcharts";
import React from "react";

const GroupsPerformanceStatisticsChart = ({
  groupPerformanceStatisticsData,
}) => {
  const chartOptions = useChart({
    xaxis: {
      categories: groupPerformanceStatisticsData.resultList.map(
        (item) => item.columnName
      ),
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "R$ " + val.toFixed(2);
        },
      },
    },
  });

  return (
    <Card style={{ height: "100%" }}>
      <CardHeader
        title="Ganhos dos Grupos"
        subheader="Os ganhos dos grupos que estão vendendo assinaturas."
      />

      <Chart
        options={chartOptions}
        series={[
          {
            name: "Ganhos dos Grupos",
            data: groupPerformanceStatisticsData.resultList.map((item) =>
              item.amount.toFixed(2)
            ),
          },
        ]}
        type="bar"
        height={300}
      />
    </Card>
  );
};

export default GroupsPerformanceStatisticsChart;
